import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SeoService } from '../../../buyer/services/seo.service';
import { CONSTANT_CUSTOMER_SUPPORT_INFO } from 'src/app/shared/ConstantCustomerSupportInfo';
@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, AfterViewInit {
  public supportInfo: typeof CONSTANT_CUSTOMER_SUPPORT_INFO;

  constructor(
    private seoService: SeoService,
  ) {
    this.supportInfo = CONSTANT_CUSTOMER_SUPPORT_INFO;
  }

  ngOnInit(): void {
    this.seoService.generateTags({
      title: "EasyKash FAQ",
      slug: "faq"
    });
  }

  ngAfterViewInit() {
    const coll = document.getElementsByClassName("collapsible");

    for (let i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function (event: any) {
        event.classList.toggle("active");
        const content = event.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }
  }
}
